import {APP_TIME_ZONE} from '../../utils/dateTime';

export function toBogotaInput(value) {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const parts = Object.fromEntries(new Intl.DateTimeFormat('en-CA', {
    timeZone: APP_TIME_ZONE, year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
  }).formatToParts(date).map(part => [part.type, part.value]));
  return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}:${parts.second}`;
}

export function closingTime(value, durationHours = 2) {
  if (!value) return null;
  const date = new Date(`${value}-05:00`);
  const hours = Number(durationHours);
  if (Number.isNaN(date.getTime()) || !Number.isFinite(hours) || hours <= 0) return null;
  return new Date(date.getTime() + hours * 60 * 60 * 1000).toISOString();
}
